import { render, staticRenderFns } from "./select-region.vue?vue&type=template&id=e4ecf6f8&scoped=true&"
import script from "./select-region.vue?vue&type=script&lang=js&"
export * from "./select-region.vue?vue&type=script&lang=js&"
import style0 from "./select-region.vue?vue&type=style&index=0&id=e4ecf6f8&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4ecf6f8",
  null
  
)

export default component.exports